export const HERO_CAROUSEL_SLIDES_MAX = 6;

export type THeroCarouselItemConfig = {
  deviceAvailability: string;
  slideCount: number;
};

export type THomePageConfigData = {
  heroCarouselItem: THeroCarouselItemConfig[];
};

export const parseHomePageConfig = (homePageConfig: THomePageConfigData): number =>
  homePageConfig?.heroCarouselItem?.filter(
    ({ deviceAvailability }) => deviceAvailability === 'site'
  )?.[0]?.slideCount || HERO_CAROUSEL_SLIDES_MAX;

export default parseHomePageConfig;
